// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
 * Following tokens have been deprecated in version 1.3.0, please update your theme:
 *
 * Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
 * 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
 * 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
 * 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
 * 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
 * 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
 * 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
 * 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
 * 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
 * 'Pill' is deprecated. Please use 'Circle' instead.
 */

import type { GDSTheme } from "@leagueplatform/genesis-core";
import "./fonts/font.css";

export const medibankWorkBetterLightTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: "#F9F7F1FF",
        secondary: "#FFFFFFFF",
        tertiary: "#E8E4DEFF",
      },
      card: {
        primary: "#FFFFFFFF",
        secondary: "#FFFFFFFF",
        disabled: "#D8D4D4FF",
      },
      screenHeader: { background: "#F4EFE4FF" },
      skeleton: {
        shimmer: {
          background: "#F4EFE4FF",
          overlay:
            "linear-gradient(90.0deg, #F4EFE400 0%, #F4EFE480 50%, #F4EFE4E5 70%, #F4EFE400 100%)",
        },
      },
    },
    onSurface: {
      text: {
        primary: "#211515FF",
        subdued: "#5E5252FF",
        reversed: "#FFFFFFFF",
        critical: "#EF4135FF",
        success: "#00AD91FF",
        warning: "#FFA800FF",
      },
      border: { subdued: "#D8D4D4FF", default: "#414042FF", card: "#FFFFFFFF" },
      icon: { primary: "#211515FF" },
    },
    interactive: {
      action: {
        primary: "#211515FF",
        hovered: "#473D3DFF",
        pressed: "#473D3DFF",
        subdued: "#5E5252FF",
        disabled: "#D8D4D4FF",
      },
      icon: { default: "#211515FF", disabled: "#D8D4D4FF" },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#FCFBF8FF",
        pressed: "#FCFBF8FF",
      },
      border: {
        default: "#D8D4D4FF",
        hovered: "#B5A9A9FF",
        disabled: "#D8D4D4FF",
        critical: { default: "#EF4135FF" },
      },
      focus: { inner: "#473D3DFF", outer: "#211515FF" },
    },
    critical: {
      background: { subdued: "#F9E1E2FF", secondary: "#FFFFFFFF" },
      border: { default: "#EF4135FF" },
      icon: "#EF4135FF",
    },
    warning: {
      background: { subdued: "#FDF8F4FF", secondary: "#FFFFFFFF" },
      border: { default: "#FFA800FF" },
      icon: "#FFA800FF",
    },
    success: {
      background: { subdued: "#EDFDF8FF", secondary: "#FFFFFFFF" },
      border: { default: "#00AD91FF" },
      icon: "#00AD91FF",
    },
    highlight: {
      background: { subdued: "#F8F9FDFF", secondary: "#FFFFFFFF" },
      border: { default: "#0996FFFF" },
      icon: "#0996FFFF",
    },
    decorative: {
      brand: {
        primary: {
          darkest: "#810049FF",
          dark: "#810049FF",
          default: "#810049FF",
          bright: "#B66B95FF",
          brightest: "#CB95B3FF",
          pastel: "#E0C0D2FF",
        },
        secondary: {
          darkest: "#00AD91FF",
          dark: "#00AD91FF",
          default: "#00AD91FF",
          bright: "#6BCFBFFF",
          brightest: "#95DDD1FF",
          pastel: "#C0EBE4FF",
        },
        tertiary: {
          darkest: "#FFA800FF",
          dark: "#FFA800FF",
          default: "#FFA800FF",
          bright: "#FFCD6BFF",
          brightest: "#FFDB95FF",
          pastel: "#FFE9C0FF",
        },
      },
    },
    primary: {
      background: {
        default: "#211515FF",
        hovered: "#473D3DFF",
        pressed: "#473D3DFF",
        critical: {
          default: "#EF4135FF",
          hovered: "#EF4135FF",
          pressed: "#EF4135FF",
        },
      },
      text: { default: "#FFFFFFFF", critical: { default: "#FFFFFFFF" } },
    },
    secondary: {
      background: {
        default: "#FFFFFFFF",
        hovered: "#FFFFFFFF",
        pressed: "#F0F0F0FF",
      },
      text: { default: "#211515FF", hovered: "#211515FF" },
      border: { default: "#FFFFFFFF" },
    },
    tertiary: {
      background: {
        default: "#F4EFE4FF",
        hovered: "#F7F3EBFF",
        pressed: "#F7F3EBFF",
      },
      text: { default: "#211515FF", hovered: "#211515FF" },
      border: { default: "#F4EFE4FF" },
    },
    input: {
      border: {
        success: "#00AD91FF",
        warning: "#FFA800FF",
        default: "#D8D4D4FF",
        hovered: "#B5A9A9FF",
        disabled: "#D8D4D4FF",
        critical: "#EF4135FF",
      },
      background: {
        default: "#FFFFFFFF",
        disabled: "#E8EAEDFF",
        hovered: "#FCFBF8FF",
        pressed: "#FCFBF8FF",
      },
    },
    dataViz: {
      interface: { track: { border: "#515151FF", background: "#D8D4D4FF" } },
      singleColor: { brand: "#211515FF", neutral: "#FBF5EFFF" },
      status: {
        critical: "#EF4135FF",
        warning: "#FFA800FF",
        success: "#00AD91FF",
      },
      categorical: {
        one: "#F58D86FF",
        two: "#FFCB66FF",
        three: "#CBE9E0FF",
        four: "#E0CCF3FF",
        five: "#F7C2D6FF",
        six: "#C2E9F8FF",
      },
    },
    tag: {
      neutral: {
        background: { bold: "#F4EFE4FF", subdued: "#F9F7F1FF" },
        border: { bold: "#F4EFE4FF", subdued: "#F9F7F1FF" },
        text: { bold: "#FFFFFFFF", subdued: "#211515FF" },
      },
      one: {
        background: { bold: "#810049FF", subdued: "#F2E1F0FF" },
        border: { bold: "#810049FF", subdued: "#F2E1F0FF" },
        text: { bold: "#810049FF", subdued: "#211515FF" },
      },
      two: {
        background: { bold: "#00AD91FF", subdued: "#C0EBE4FF" },
        border: { bold: "#00AD91FF", subdued: "#C0EBE4FF" },
        text: { bold: "#FFFFFFFF", subdued: "#211515FF" },
      },
      three: {
        background: { bold: "#FFA800FF", subdued: "#FFE9C0FF" },
        border: { bold: "#FFA800FF", subdued: "#FFE9C0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#211515FF" },
      },
      four: {
        background: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        border: { bold: "#870644FF", subdued: "#F2E1F0FF" },
        text: { bold: "#FFFFFFFF", subdued: "#211515FF" },
      },
      success: {
        background: { bold: "#00AD91FF", subdued: "#EDFDF8FF" },
        border: { bold: "#00AD91FF", subdued: "#EDFDF8FF" },
        text: { bold: "#FFFFFFFF", subdued: "#00AD91FF" },
      },
      warning: {
        background: { bold: "#FFA800FF", subdued: "#FDF8F4FF" },
        border: { bold: "#FFA800FF", subdued: "#FDF8F4FF" },
        text: { bold: "#FFFFFFFF", subdued: "#FFA800FF" },
      },
      critical: {
        background: { bold: "#EF4135FF", subdued: "#F9E1E2FF" },
        border: { bold: "#EF4135FF", subdued: "#F9E1E2FF" },
        text: { bold: "#FFFFFFFF", subdued: "#EF4135FF" },
      },
      informational: {
        background: { bold: "#0996FFFF", subdued: "#F8F9FDFF" },
        border: { bold: "#0996FFFF", subdued: "#F8F9FDFF" },
        text: { bold: "#FFFFFFFF", subdued: "#0996FFFF" },
      },
    },
  },
  shadows: {
    card: { x: 0, y: 0, blur: 0, spread: 0, color: "#00000000" },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: "#0000001A" },
  },
  typography: {
    headingOne: {
      fontFamily: "Euclid Circular A",
      fontWeight: 500,
      lineHeight: 46,
      fontSize: 38,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingTwo: {
      fontFamily: "Euclid Circular A",
      fontWeight: 500,
      lineHeight: 34,
      fontSize: 28,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingThree: {
      fontFamily: "Euclid Circular A",
      fontWeight: 500,
      lineHeight: 29,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    headingFour: {
      fontFamily: "Euclid Circular A",
      fontWeight: 500,
      lineHeight: 24,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleOne: {
      fontFamily: "Euclid Circular A",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    subtitleTwo: {
      fontFamily: "Euclid Circular A",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOne: {
      fontFamily: "Euclid Circular A",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyOneSecondary: {
      fontFamily: "Euclid Circular A",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwo: {
      fontFamily: "Euclid Circular A",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    bodyTwoSecondary: {
      fontFamily: "Euclid Circular A",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: "none",
      textDecoration: "none",
    },
    buttonOne: {
      fontFamily: "Euclid Circular A",
      fontWeight: 600,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    buttonTwo: {
      fontFamily: "Euclid Circular A",
      fontWeight: 600,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    label: {
      fontFamily: "Euclid Circular A",
      fontWeight: 500,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    overline: {
      fontFamily: "Euclid Circular A",
      fontWeight: 600,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: "uppercase",
      textDecoration: "none",
    },
    caption: {
      fontFamily: "Euclid Circular A",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
    tab: {
      fontFamily: "Euclid Circular A",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: "none",
      textDecoration: "none",
    },
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
    eighth: 2,
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6,
    progressBar: 9999,
    tags: 4,
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000,
  },
  rem: {
    fontSizes: {
      headingOne: 2.375,
      headingTwo: 1.75,
      headingThree: 1.5,
      headingFour: 1.25,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625,
    },
    lineHeights: {
      headingOne: 2.875,
      headingTwo: 2.125,
      headingThree: 1.8125,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75,
    },
    baseSize: 16,
  },
  fonts: { headings: "Euclid Circular A", body: "Euclid Circular A" },
  transitions: { defaultTime: "200ms" },
};
